query (
  $id: String!
) {
  getPaymentStatus(
    id: $id
  )
}
